export const userData = [
    {
        "user_rank": "Captain",
        "user_first_name": "John",
        "user_first_last_name": "Smith",
        "user_personal_number": 1001,
        "user_designation": "Operations Manager",
        "user_directorate_unit": "Logistics",
        "user_role": "Admin"
    },
    {
        "user_rank": "Lieutenant",
        "user_first_name": "Sarah",
        "user_first_last_name": "Johnson",
        "user_personal_number": 1002,
        "user_designation": "Intelligence Officer",
        "user_directorate_unit": "Intelligence",
        "user_role": "Editor"
    },
    {
        "user_rank": "Major",
        "user_first_name": "David",
        "user_first_last_name": "Brown",
        "user_personal_number": 1003,
        "user_designation": "Security Specialist",
        "user_directorate_unit": "Security",
        "user_role": "Reviewer"
    },
    {
        "user_rank": "Corporal",
        "user_first_name": "Maria",
        "user_first_last_name": "Ramirez",
        "user_personal_number": 1004,
        "user_designation": "HR Coordinator",
        "user_directorate_unit": "Human Resources",
        "user_role": "User"
    },
    {
        "user_rank": "Sergeant",
        "user_first_name": "Emily",
        "user_first_last_name": "Davis",
        "user_personal_number": 1005,
        "user_designation": "Network Engineer",
        "user_directorate_unit": "Information Technology",
        "user_role": "Admin"
    },
    {
        "user_rank": "Commander",
        "user_first_name": "Chen",
        "user_first_last_name": "Li",
        "user_personal_number": 1006,
        "user_designation": "Project Lead",
        "user_directorate_unit": "Operations",
        "user_role": "Editor"
    },
    {
        "user_rank": "Private",
        "user_first_name": "Robert",
        "user_first_last_name": "Turner",
        "user_personal_number": 1007,
        "user_designation": "Field Analyst",
        "user_directorate_unit": "Field Unit",
        "user_role": "User"
    },
    {
        "user_rank": "Lieutenant",
        "user_first_name": "Aisha",
        "user_first_last_name": "Khan",
        "user_personal_number": 1008,
        "user_designation": "Cybersecurity Expert",
        "user_directorate_unit": "IT Security",
        "user_role": "Reviewer"
    },
    {
        "user_rank": "Captain",
        "user_first_name": "Samuel",
        "user_first_last_name": "Park",
        "user_personal_number": 1009,
        "user_designation": "Communications Lead",
        "user_directorate_unit": "Communications",
        "user_role": "Admin"
    },
    {
        "user_rank": "Major",
        "user_first_name": "Elena",
        "user_first_last_name": "Petrova",
        "user_personal_number": 1010,
        "user_designation": "Policy Advisor",
        "user_directorate_unit": "Policy Division",
        "user_role": "Editor"
    }
]

export const schemeData = [
    {
        "schemeId": 1,
        "schemeName": "Revenue",
        "description": "General revenue scheme",
        "status": "Active"
    },
    {
        "schemeId": 2,
        "schemeName": "ROP",
        "description": "Research and operations program",
        "status": "Active"
    },
    {
        "schemeId": 3,
        "schemeName": "TDF",
        "description": "Technology development fund",
        "status": "Active"
    },
    {
        "schemeId": 4,
        "schemeName": "iDEX",
        "description": "Innovation for defense excellence",
        "status": "Active"
    },
    {
        "schemeId": 5,
        "schemeName": "iDEX 4 Fauji",
        "description": "Innovation program specifically for servicemen",
        "status": "Active"
    },
    {
        "schemeId": 6,
        "schemeName": "Make I",
        "description": "First stage of project-based manufacturing",
        "status": "Pending"
    },
    {
        "schemeId": 7,
        "schemeName": "Make II",
        "description": "Second stage of project-based manufacturing",
        "status": "Pending"
    },
    {
        "schemeId": 8,
        "schemeName": "Make III",
        "description": "Third stage of project-based manufacturing",
        "status": "Pending"
    },
    {
        "schemeId": 9,
        "schemeName": "Open",
        "description": "Open scheme for general proposals",
        "status": "Active"
    },
    {
        "schemeId": 10,
        "schemeName": "Aditi",
        "description": "Special scheme for advanced innovations",
        "status": "Active"
    }
]

export const proposalData =[
    {
      name: 'Proposal 1',
      description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur corrupti quibusdam voluptate totam! Nisi molestias doloremque voluptate esse! Debitis, dolore.',
      schemeType: 'Make-I Scheme',
      currentStage: 1,
      totalStages: 7,
      completion: 0,
      created: '25/3/2025',
      status: 'Active',
      proposals: 0
    },
    {
      name: 'Alpha',
      description: 'Initial design and planning phase ',
      schemeType: 'Make-II Scheme',
      currentStage: 3,
      totalStages: 5,
      completion: 60,
      created: '12/1/2025',
      status: 'In Progress',
      proposals: 4
    },
    {
      name: 'Beta',
      description: 'Execution stage underway',
      schemeType: 'Technology Development',
      currentStage: 5,
      totalStages: 6,
      completion: 80,
      created: '01/2/2025',
      status: 'Pending Review',
      proposals: 7
    },
    {
      name: 'Gamma',
      description: 'Prototype review completed',
      schemeType: 'Make-I Scheme',
      currentStage: 6,
      totalStages: 7,
      completion: 85,
      created: '20/2/2025',
      status: 'Pending Approval',
      proposals: 2
    },
    {
      name: 'Delta',
      description: 'Final evaluation phase',
      schemeType: 'Make-III Scheme',
      currentStage: 4,
      totalStages: 4,
      completion: 100,
      created: '10/3/2025',
      status: 'Completed',
      proposals: 5
    },
    {
      name: 'Epsilon',
      description: 'Waiting for proposal submissions',
      schemeType: 'Technology Acquisition',
      currentStage: 1,
      totalStages: 4,
      completion: 10,
      created: '05/3/2025',
      status: 'Active',
      proposals: 1
    },
    {
      name: 'Zeta',
      description: 'Under initial assessment',
      schemeType: 'Make-II Scheme',
      currentStage: 2,
      totalStages: 5,
      completion: 25,
      created: '15/2/2025',
      status: 'In Progress',
      proposals: 3
    },
    {
      name: 'Eta',
      description: 'Prototype development started',
      schemeType: 'Make-I Scheme',
      currentStage: 3,
      totalStages: 6,
      completion: 45,
      created: '18/3/2025',
      status: 'In Progress',
      proposals: 6
    },
    {
      name: 'Theta',
      description: 'Final documentation stage',
      schemeType: 'Technology Development',
      currentStage: 6,
      totalStages: 6,
      completion: 95,
      created: '22/3/2025',
      status: 'Pending Approval',
      proposals: 8
    },
    {
      name: 'Iota',
      description: 'Initial groundwork complete',
      schemeType: 'Make-II Scheme',
      currentStage: 2,
      totalStages: 5,
      completion: 35,
      created: '27/3/2025',
      status: 'In Progress',
      proposals: 2
    }
  ];
  

export const technicalEvaluationData = [
    {
      "vendorName": "M/s Relaza Pvt Ltd",
      "technicalRank": "L1",
      "technicalScore": 92,
      "remarks": "Best overall technical proposal"
    },
    {
      "vendorName": "M/s Quixy",
      "technicalRank": "L2",
      "technicalScore": 89,
      "remarks": "Strong technical compliance"
    },
    {
      "vendorName": "M/s EPPS Infotech Pvt Ltd",
      "technicalRank": "L3",
      "technicalScore": 87,
      "remarks": "Compliant with minor gaps"
    },
    {
      "vendorName": "M/s Illizen Pvt Ltd",
      "technicalRank": "L4",
      "technicalScore": 85,
      "remarks": "Meets minimum technical requirements"
    },
    {
      "vendorName": "M/s Sinaxis Pvt Ltd",
      "technicalRank": "L5",
      "technicalScore": 82,
      "remarks": "Requires clarification on few points"
    },
    {
      "vendorName": "M/s Transworld Pvt Ltd",
      "technicalRank": "L6",
      "technicalScore": 80,
      "remarks": "Acceptable technical performance"
    },
    {
      "vendorName": "M/s Verge Impex",
      "technicalRank": "L7",
      "technicalScore": 78,
      "remarks": "Low innovation in solution"
    },
    {
      "vendorName": "M/s Firm's Name 1",
      "technicalRank": "L8",
      "technicalScore": 74,
      "remarks": "Lacked clarity in documentation"
    },
    {
      "vendorName": "M/s Firm's Name 2",
      "technicalRank": "L9",
      "technicalScore": 70,
      "remarks": "Incomplete technical annexures"
    },
    {
      "vendorName": "M/s Firm's Name 3",
      "technicalRank": "L10",
      "technicalScore": 65,
      "remarks": "Non-compliance to key criteria"
    }
  ]
  
